module.exports = __webpack_public_path__ + "img/ic-timer.201894b0.svg";